import axios from "axios";
import {getCookie} from "./cookie";

const API2_URL = process.env.REACT_APP_API2_URL

export const itemAPI2 = {
    baseUrl: process.env.REACT_APP_API2_URL,

    getItemEstimate: function (priceType,mallId) {
        const _url =
            mallId ?
                this.baseUrl + `/desktop/v1/minishop/${mallId}/estimate/capture/${priceType}`
                :
                this.baseUrl + `/desktop/v1/pc/estimate/capture/${priceType}`
        const config = {
            headers: {'Authorization': `Bearer ${getCookie('auth_token')}`},
            withCredentials: true,
        }
        return axios.get(_url, config)
    },
    getItemEstimatePrint: function (priceType,estimateIdx,mallId) {
        const _url =
            mallId ?
                this.baseUrl + `/desktop/v1/minishop/${mallId}/estimate/${estimateIdx}/print`
                :
                // this.baseUrl + `/desktop/v1/pc/estimate/capture/${priceType}`
                this.baseUrl + `/desktop/v1/pc/estimate/${estimateIdx}/print`
        return axios.get(_url,{withCredentials:true})
    },
    setItemEstimate: function (mallId) {
        const _url =
            mallId?
                this.baseUrl + `/desktop/v1/minishop/${mallId}/estimate`
                :
                this.baseUrl + `/desktop/v1/pc/estimate`
        const headerParameter = {
            'Authorization': `Bearer ${getCookie('auth_token')}`,
        }
        return axios.post(_url,{},{headers: headerParameter, withCredentials: true})
    },

    getShareItemEstimate: function (estimate_idx) {
        const _url =
            this.baseUrl +
            `/desktop/v1/pc/estimate/${estimate_idx}`
        return axios(_url,{method:'GET', withCredentials:true})
    },

    getAlias:function (category_id){
        const _url = this.baseUrl +`/desktop/v1/shopping/categories/${category_id}/alias`
        return axios(_url,{method:'GET', withCredentials:true})
    },

    getServiceList(){
        const url = `${API2_URL}/desktop/v1/pc/services`
        const params = {}
        const config = {
            headers: {'Authorization': `Bearer ${getCookie('auth_token')}`},
            params:params,
            withCredentials: true,
        }
        return axios.get(url, config)
    },

    getServiceInfo(item_id){
        const url = `${API2_URL}/desktop/v1/pc/services/${item_id}`
        const params = {}
        const config = {
            headers: {'Authorization': `Bearer ${getCookie('auth_token')}`},
            params:params,
            withCredentials: true,
        }
        return axios.get(url, config)
    },

    setServicePlus(item_id, count){
        const params = {item_id:item_id, count:count}
        const url = `${API2_URL}/desktop/v1/cart/services`
        const config = {
            headers: {'Authorization': `Bearer ${getCookie('auth_token')}`},
            withCredentials: true,
        }
        return axios.post(url, params, config)
    },
    deleteService(item_id){
        const url = `${API2_URL}/desktop/v1/pc/services/${item_id}`
        const config = {
            headers: {'Authorization': `Bearer ${getCookie('auth_token')}`},
            withCredentials: true,
        }
        return axios.delete(url, config)
    },

}



// WEBPACK FOOTER //
// ./src/estimate_list/libs/api2.js